import axios from "axios";
import { saveAs } from "file-saver";
import { getToken } from "@/utils/auth";
import modal from "@/plugins/modal";

const baseURL = process.env.VUE_APP_BASE_API;

export default {
  name(data, name) {
    modal.loading("正在下载数据，请稍候");
    var url = baseURL + "/file/downloadFileById";
    axios({
      method: "post",
      url: url,
      data,
      responseType: "blob",
      headers: { Authorization: "Bearer " + getToken() }
    })
      .then((res) => {
        if (res.data.type !== "application/json") {
          const blob = new Blob([res.data]);
          this.saveAs(blob, name);
        } else {
          modal.confirm("下载文件出现错误，请联系管理员！");
        }
        modal.closeLoading();
      })
      .catch((r) => {
        modal.confirm("下载文件出现错误，请联系管理员！");
        modal.closeLoading();
      });
  },
  zip(data, name) {
    var url = baseURL + "file/commonDownloadFiles";
    modal.loading("正在下载数据，请稍候");
    axios({
      method: "post",
      url: url,
      data,
      responseType: "blob",
      headers: { Authorization: "Bearer " + getToken() }
    })
      .then((res) => {
        if (res.data.type !== "application/json") {
          const blob = new Blob([res.data], { type: "application/zip" });
          this.saveAs(blob, name);
        } else {
          modal.confirm("下载文件出现错误，请联系管理员！");
        }
        modal.closeLoading();
      })
      .catch((r) => {
        modal.confirm("下载文件出现错误，请联系管理员！");
        modal.closeLoading();
      });
  },
  saveAs(text, name, opts) {
    saveAs(text, name, opts);
  }
};
